<style>

.tableDesign .el-input__inner{
  border: 0;
  text-align: center;
}
</style>
<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <el-row :gutter="10" class="mb8">
            <el-button type="primary" size="mini" @click="handleAdd()">新增</el-button>
            <el-button v-prevent-re-click type="primary" size="mini" style="margin:10px 10px" @click="handleSaveConfig(type)">保存</el-button>
            <clear-cache-apply />
            <sync-data />
          </el-row>
        </div>
        <el-table class="tableDesign" size="mini" :data="list" border style="width: 60%">
          <el-table-column label="序号" align="center" width="100">
            <template v-slot:default="{row}">
              <span style="display:block;" :title="row.id">{{ row.id }}</span>
            </template>
          </el-table-column>
          <el-table-column label="名称" align="center">
            <template v-slot:default="{row}">
              <el-input v-model="row.name" style="width: 250px;" placeholder="名称" />
            </template>
          </el-table-column>
          <el-table-column label="皮肤ID" align="center">
            <template v-slot:default="{row}">
              <el-input v-model="row.resourceId" style="width: 250px;" placeholder="皮肤ID" />
            </template>
          </el-table-column>
          <el-table-column label="点击次数" align="center">
            <template v-slot:default="{row}">
              <el-input v-model="row.num" style="width: 250px;" placeholder="点击次数" />
            </template>
          </el-table-column>
          <el-table-column label="奖励" align="center">
            <template v-slot:default="{row}">
              <Reward v-model="row.reward" :exclude="[86]" />
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>

import Reward from '@/components/Reward'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import { actionPinata, pinata } from '@/api/config/api'
import SyncData from '@/components/syncData/index.vue'

export default {
  name: 'Pinata',
  components: { SyncData, ClearCacheApply, Reward },
  data() {
    return {
      loading: false,
      list: []
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.getList()
    },
    getList() {
      this.loading = true
      pinata().then(response => {
        this.list = response.data
        this.loading = false
      })
    },
    handleAdd() {
      this.list.push({ id: 0, name: '新增配置', num: 3, resourceId: 1, reward: [] })
    },
    handleSaveConfig() {
      actionPinata({ data: JSON.stringify(this.list) }).then(response => {
        this.msgSuccess('保存成功', () => {
          this.getList()
        }, 1000)
      })
    },
    countId() {
      let id = 0
      for (let i = 0; i < this.list.length; i++) {
        id = this.list[i].id
      }
      return id + 1
    }
  }
}
</script>

